import { createAction as makeActionCreator } from 'redux-actions';
import moment from 'moment';

import api from '../api/';
import i18n from '../i18n';
import { fetchPathAfterLogin, loadRoot, saveStateAndSelectionHandler } from './booking';
import { organizationReceived } from './organization';
import { checkUserFailure, identifyUserStart, identifyUserSuccess, bankAuthenticationStarted, bankAuthenticationLinkReceived } from './session';
import { handleError } from './errors';
import { fetchUponLogin } from './ehrResources';

export const fetchingLocalizations = makeActionCreator('FETCHING_LOCALIZATIONS');
export const loadingConfiguration = makeActionCreator('LOADING_CONFIGURATION');
export const configurationLoaded = makeActionCreator('CONFIGURATION_LOADED');
export const localizationsFetched = makeActionCreator('LOCALIZATIONS_FETCHED');
export const loginOnlyBySsoView = makeActionCreator('SHOW_LOGIN_ONLY_BY_SSO_VIEW');

let languages = [];

const getLocalizations = options => new Promise((resolve, reject) => {
  // initialize the i18n localization first to avoid showing the key strings
  console.log('LOCALIZATIONS INITIALIZE:', options);
  i18n.loadLanguages(languages, (err, t) => {
    console.log('All languages fetched');
    // request all the namespaces for all the languages
    api.requestAllByLanguages(languages, options.ns)
      .then((localizationsByLanguage) => {
        // localizationsByLanguage is an array with the language and the namespace map
        localizationsByLanguage.forEach((localizationByLanguage) => {
          const { language, namespaceMap } = localizationByLanguage;
          // the map contains the name of the namespace and the dictionary (data) of translations
          namespaceMap.forEach((namespaceEntry) => {
            const { namespaceName, namespaceData } = namespaceEntry;
            i18n.addResourceBundle(language, namespaceName, namespaceData, true, true);
          });
        });
        // we have finished assigning the namespaces in all the languages
        resolve();
      })
      .catch((error) => { reject(error) });
  });
});

export const requestAuthentication = dispatch => (method, createUserIfNotExists) => {
  dispatch(bankAuthenticationStarted());
  api.requestAuthentication(method, createUserIfNotExists)
    .then((data) => {
      const { url } = data;
      dispatch(bankAuthenticationLinkReceived());
      dispatch(saveStateAndSelectionHandler)();
      // console.log(url);
      window.location.replace(url);
    })
    .catch((error) => {
      dispatch(bankAuthenticationLinkReceived());
      console.log(error);
    });
};

export const loadPathNamespace = (pathNamespace, employerId) => new Promise((resolve, reject) => {
  if (!pathNamespace) {
    resolve();
    return;
  }

  // Clean the previously existing (if any) bundle with this path namespace.
  languages.forEach(language => i18n.removeResourceBundle(language, pathNamespace));

  api.requestAllByLanguages(languages, [pathNamespace], employerId)
    .then((localizationsByLanguage) => {
      // localizationsByLanguage is an array with the language and the namespace map
      localizationsByLanguage.forEach((localizationByLanguage) => {
        const { language, namespaceMap } = localizationByLanguage;
        // the map contains the name of the namespace and the dictionary (data) of translations
        namespaceMap.forEach((namespaceEntry) => {
          const { namespaceName, namespaceData } = namespaceEntry;
          i18n.addResourceBundle(language, namespaceName, namespaceData, true, true);
        });
      });
      // we have finished assigning the namespaces in all the languages
      resolve();
    })
    .catch((error) => { reject(error) });
});

export const loadConfiguration = (dispatch, getState) => () => {
  const { booking, session } = getState();
  dispatch(loadingConfiguration());
  i18n.on('initialized', (options) => {
    moment.locale('fi');
    dispatch(fetchingLocalizations());
    api.requestOrganization()
      .then((organizationData) => {
        dispatch(organizationReceived(organizationData));
        languages = organizationData.locales.map(locale => locale.split('_')[0]);
        getLocalizations(options)
          .then(() => {
            //  if language in i18n taken from cookie doesn't exist in organization's locales, change it to organization's default language
            if (!languages.includes(i18n.language)) {
              //  take the default locale for organization. if default locale is not supported, then take Finnish
              const newLocale = !languages.includes(organizationData.defaultLocale.split('_')[0]) ? 'fi' : organizationData.defaultLocale.split('_')[0];
              i18n.changeLanguage(newLocale);
            }
            // after all the localizations are loaded then we fetch the configurations
            dispatch(localizationsFetched());
            dispatch(identifyUserStart());
            api.checkUser()
              .then(data => dispatch(identifyUserSuccess(data)))
              .then(() => dispatch(loadRoot)())
              .then(() => dispatch(fetchUponLogin)())
              // in case user came after strong authentication we fetch originally selected path
              .then(() => dispatch(fetchPathAfterLogin)())
              // if user came after bank auth being in self paid path, load path localizations as pathconfig is not loaded second time
              .then(() => new Promise((resolve) => {
                if (booking.pathNamespace) {
                  loadPathNamespace(booking.pathNamespace, null)
                    .then(() => resolve());
                } else {
                  resolve();
                }
              }))
              .then(() => dispatch(configurationLoaded()))
              .catch(() => {
                dispatch(checkUserFailure('User is not logged in.'));
                dispatch(loadRoot)();
                dispatch(configurationLoaded());
              });
          });
      })
      .catch(() => {
        dispatch(configurationLoaded());
        return dispatch(handleError);
      });
  });
};

export const triggerLoginOnlyBySsoView = dispatch => () => dispatch(loginOnlyBySsoView());



// WEBPACK FOOTER //
// ./src/actions/app.js